export default "__VITE_ASSET__YB57MEa$__"